"use strict";

require("core-js/modules/es.object.assign.js");

require("core-js/modules/web.dom-collections.iterator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.parse-int.js");

var _reactDatepicker = _interopRequireWildcard(require("react-datepicker"));

require("react-datepicker/dist/react-datepicker.css");

var _DatePicker = require("./DatePicker.Styled");

var _de = _interopRequireDefault(require("date-fns/locale/de"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

(0, _reactDatepicker.registerLocale)('de', _de.default);
(0, _reactDatepicker.setDefaultLocale)('de');

const DatePicker = _ref => {
  let {
    value,
    onChange,
    label,
    mode = 'day'
  } = _ref;

  const getProps = () => {
    const props = {};

    if (mode === 'year') {
      props.showYearPicker = true;
      props.dateFormat = 'yyyy';
    } else if (mode === 'month') {
      props.showMonthYearPicker = true;
      props.dateFormat = 'MM.yyyy';
    } else {
      props.dateFormat = 'dd.MM.yyyy';
      props.showYearDropdown = true;
    }

    return props;
  };

  const getValue = () => {
    if (mode === 'year' && (typeof value === 'string' || typeof value === 'number')) {
      const date = new Date();
      date.setFullYear(typeof value === 'string' ? parseInt(value) : value);
      return date;
    } else if (mode === 'month' && typeof value === 'string') {
      const date = new Date();
      const valueSplit = value.split('/');
      if (valueSplit.length !== 2) return false;
      date.setMonth(valueSplit[0]);
      date.setFullYear(valueSplit[1]);
      return date;
    } else if (mode === 'day' && value instanceof Date) {
      return value;
    }

    return false;
  };

  const internalOnChange = value => {
    if (mode === 'year') {
      const date = new Date(value);
      onChange(date.getFullYear());
    } else if (mode === 'month') {
      const date = new Date(value);
      onChange("".concat(date.getMonth(), "/").concat(date.getFullYear()));
    } else {
      onChange(value);
    }
  };

  if (!value || typeof onChange !== 'function' || !mode || !getValue()) return false;
  return /*#__PURE__*/_react.default.createElement(_DatePicker.Wrapper, null, label && /*#__PURE__*/_react.default.createElement(_DatePicker.Label, null, label), /*#__PURE__*/_react.default.createElement(_reactDatepicker.default, _extends({
    selected: getValue(),
    onChange: internalOnChange
  }, getProps())));
};

var _default = DatePicker;
exports.default = _default;